import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../Icon';
import Label from '../Label';
import Tooltip from '../Tooltip';
import styles from './FolderPickerItem.module.css';

const bindClasses = classNameBind.bind(styles);

const FolderPickerItem = ({ id, disabledMsg = null, onClick, name }) => (
  <Tooltip
    key={id}
    content={disabledMsg}
  >
    <div
      className={bindClasses('folder', { disabled: !!disabledMsg })}
      onClick={() => { if (!disabledMsg) onClick(id); }}
      role="button"
      tabIndex="0"
    >
      <Icon name="folder-closed" color="original" />
      <Label cutText>{name}</Label>
      <Icon name="chevron-right" />
    </div>
  </Tooltip>
);

export default FolderPickerItem;
